import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Document, Page } from 'react-pdf';

// In this component you will have to use two props :
// 1. url (this is one of props where you will have to pass url of the pdf)
// 2. onDeleteClick (this is a callback function which is going to be used for removing the current pdfurl. It will be called on clicking the close button).
// ex <PDFViewer url="" onDeleteClick={this.onDelete} />

export default class PDFViewer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			pageNumber: 1
		}
		this.onDeleteClick = this.onDeleteClick.bind(this);
	}

	onDeleteClick() {
		if(this.props.onDeleteClick) {
			this.props.onDeleteClick();
		}
	}

	setLoadingDone() {
		this.setState({pageNumber: 1})
	}

	loadingBox() {
		return (
			<div className='pdf-viewer-loader'>
			    <CircularProgress className='black-color' size={60} thickness={4} />
			</div>
		);
	}

	render() {

		const { url, onDeleteClick  } = this.props;
		const { pageNumber } = this.state;
		const filePath = '/api/inwarding/documents/?documentId='+ url;

		return (
			<div className="panel-body pdf-viewer-container">
				<Document  
					file={{url: filePath}} 
					renderMode="canvas" 
					className={'small-pdf-viewer'} 
					loading={this.loadingBox()}
				>
					<Page pageNumber={pageNumber} />
				</Document>
			    <div className="panel-default-overlay-up text-center">
			    	{
					(onDeleteClick)?
			        	<span 
							onClick={this.onDeleteClick} 
							className="label label-default pdf-viewer-cross-icon"
						> 
							X 
						</span>
					:null
			    	}
			        <a 
						className="btn btn-jt-cancel-gr pdf-viewer-open-pdf-link" 
						target="_blank" 
						href={filePath} 
						role="button"
					>
			        	OPEN PDF <span className="glyphicon glyphicon-new-window" aria-hidden="true"></span>
			        </a>
			    </div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/commons/PDFViewer.js